"use client";

import { useState } from 'react';
import Link from 'next/link';
import { ChevronDown, X } from 'lucide-react';

export default function TechnologyMobileNavigation({ open, onClose, items = [], logo, siteName }) {
  const [expanded, setExpanded] = useState({});
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] lg:hidden">
      <button aria-label="Close menu" className="absolute inset-0 bg-black/45" onClick={onClose} />
      <aside aria-label="Mobile navigation" className="relative flex h-full w-[min(90vw,390px)] flex-col bg-white text-black shadow-2xl">
        <div className="flex min-h-20 items-center justify-between border-b border-[#e5e5e5] px-5">
          <Link href="/" onClick={onClose} className="flex min-w-0 items-center">
            {logo ? <img src={logo} alt={siteName} className="max-h-10 max-w-[230px] object-contain object-left" /> : <span className="truncate text-xl font-black">{siteName}</span>}
          </Link>
          <button aria-label="Close menu" onClick={onClose} className="ml-4 rounded-full p-2 transition-colors hover:bg-[#f1f1f1] hover:text-[#929191]">
            <X className="h-6 w-6" />
          </button>
        </div>
        <nav aria-label="Mobile primary navigation" className="flex-1 overflow-y-auto py-3">
          <ul>
            {items.map(item => {
              const isExpanded = Boolean(expanded[item.id]);
              return (
                <li key={item.id} className="border-b border-[#eeeeee]">
                  <div className="flex items-center">
                    <Link href={item.href} onClick={onClose} className="flex-1 px-6 py-4 text-[15px] font-bold uppercase tracking-wide transition-colors hover:bg-[#f1f1f1] hover:text-[#929191]">
                      {item.label}
                    </Link>
                    {item.children.length > 0 && (
                      <button aria-label={`Toggle ${item.label} links`} aria-expanded={isExpanded} onClick={() => setExpanded(current => ({ ...current, [item.id]: !isExpanded }))} className="p-4 transition-colors hover:bg-[#f1f1f1] hover:text-[#929191]">
                        <ChevronDown className={`h-5 w-5 transition-transform ${isExpanded ? 'rotate-180' : ''}`} />
                      </button>
                    )}
                  </div>
                  {item.children.length > 0 && isExpanded && (
                    <ul className="border-t border-[#eeeeee] bg-[#f7f7f7] py-2">
                      {item.children.map(child => <li key={child.id}><Link href={child.href} onClick={onClose} className="block px-9 py-3 text-sm transition-colors hover:text-[#929191]">{child.label}</Link></li>)}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>
      </aside>
    </div>
  );
}
